module.exports = __webpack_public_path__ + "assets/img/button.0227f555.png";